/**
 * Queue-manager bounded-context widget registry: the two queue load widgets, both gated by the
 * `@Auth` permission of the read API they consume. Spread `queueManagerWidgetProviders` in
 * `aurora-widget.providers.ts`.
 */
import { provideWidget, WIDGET_CATEGORY } from '@aurora/modules/widget';

const QUEUE_MANAGER_PERMISSION = 'queue-manager.read';

export const queueManagerWidgetProviders = [
  provideWidget({
    id: 'queue-manager.queue-load',
    translation: 'dashboard.widgets.queueManager.QueueLoad',
    description: 'dashboard.widgets.queueManager.QueueLoadDescription',
    iconUrl: 'https://api.iconify.design/lucide/gauge.svg?color=%23ef4444',
    permission: QUEUE_MANAGER_PERMISSION,
    category: WIDGET_CATEGORY.SYSTEM,
    span: {
      minCols: 3,
      maxCols: 8,
      minRows: 4,
      maxRows: 8,
      defaultCols: 4,
      defaultRows: 5,
    },
    component: () => import('./queue-load.widget').then((m) => m.QueueLoadWidgetComponent),
  }),
  provideWidget({
    id: 'queue-manager.queue-load-history',
    translation: 'dashboard.widgets.queueManager.QueueLoadHistory',
    description: 'dashboard.widgets.queueManager.QueueLoadHistoryDescription',
    iconUrl: 'https://api.iconify.design/lucide/chart-line.svg?color=%23ef4444',
    permission: QUEUE_MANAGER_PERMISSION,
    category: WIDGET_CATEGORY.SYSTEM,
    span: {
      minCols: 4,
      maxCols: 12,
      minRows: 4,
      maxRows: 8,
      defaultCols: 6,
      defaultRows: 5,
    },
    component: () =>
      import('./queue-load-history.widget').then((m) => m.QueueLoadHistoryWidgetComponent),
  }),
];
